import { render } from "./Teachers.vue?vue&type=template&id=1b15f47c&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"

import "./Teachers.vue?vue&type=style&index=0&id=1b15f47c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b15f47c"]])

export default __exports__